export enum ICON_SIZE {
  SMALL= '16px',
  MEDIUM= '20px',
  LARGE= '24px'
}

export enum SCANNABILITY_SCORE {
  UNSCANNABLE = 'UNSCANNABLE',
  POOR = 'POOR',
  GOOD = 'GOOD',
  EXCELLENT = 'EXCELLENT'
}
